var _defs, _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBorderUpdates(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 333.6 540.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#ff9c02;}.cls-3{fill:#0d5d83;}.cls-4{fill:#049d66;}.cls-5{fill:#f60809;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1_copy_2",
    "data-name": "Rectangle 1 copy 2",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1_copy_2-2",
    "data-name": "Rectangle 1 copy 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M43.68,547.92a20.4,20.4,0,0,1-20.4-20.4v-336H13.2v338.4A28.79,28.79,0,0,0,42,558.72H187.92v-10.8Z",
    transform: "translate(-13.2 -17.76)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2-2",
    "data-name": "Rectangle 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M42,17.76a28.79,28.79,0,0,0-28.8,28.8v145H23.28V48.24a20.4,20.4,0,0,1,20.4-20.4H211V17.76Z",
    transform: "translate(-13.2 -17.76)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2_copy",
    "data-name": "Rectangle 2 copy",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2_copy-2",
    "data-name": "Rectangle 2 copy"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M318,17.76H211V27.84H316.32a20.4,20.4,0,0,1,20.4,20.4V313.68H346.8V46.56A28.79,28.79,0,0,0,318,17.76Z",
    transform: "translate(-13.2 -17.76)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2_copy_2",
    "data-name": "Rectangle 2 copy 2",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2_copy_2-2",
    "data-name": "Rectangle 2 copy 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M336.72,313.68V527.52a20.4,20.4,0,0,1-20.4,20.4H187.92v10.8H318a28.79,28.79,0,0,0,28.8-28.8V313.68Z",
    transform: "translate(-13.2 -17.76)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorderUpdates);
export default __webpack_public_path__ + "static/media/Border_Updates.d2f330c66e9b7c3edce0f8e3230863c1.svg";
export { ForwardRef as ReactComponent };